import axios from "axios";

const normalizeFormValue = (value) => {
    if (typeof value === 'boolean') {
        return value ? '1' : '0'
    }

    if (value === 'true' || value === 'false') {
        return value === 'true' ? '1' : '0'
    }

    return value
}

// Setup : make sure that you have install alpinejs and import them to resources/js/bootstrap
// import Alpine from 'alpinejs'
// window.Alpine = Alpine

// Move these code to resources/js/bootstrap
// import editResource from "./resources/edit.js";
// Alpine.data('editResource',editResource)

// Alpine.start()

export default (url = null, payload = {}) => ({
    loading: false,
    message: null,
    haveError: false,
    file: null,
    success: false,

    handleFile(event) {
        this.file = event.target.files[0];
    },

    handle () {

        if (this.loading) {
            return;
        }

        this.loading = true;
        this.haveError = false;

        axios.post(url, this._payload()).then(response => {

            if (response.data.error) {
                this.haveError = true;
                this.message = response?.data?.message;
            } else {

                this.success = true;
                setTimeout(() => {
                    this._redirectTo()
                }, 1000)
            }

        }).catch(error => {
            this.haveError = true;
            this.message = error.response.data.message;
        }).finally(() => {
            setTimeout(() => {
                this.loading = false
            }, 1000)

        })
    },

    init() {
        this._hydrate();
    },

    _hydrate() {

        const data = JSON.parse(payload)

        //console.log('payload', data)
        //console.log('resource for : url', url)

        for (const key in data) {
            this[key] = data[key]
        }
    },

    _payload() {

        const data = JSON.parse(payload)

        //let values = {}
        const formData = new FormData();
        const that = this

        for (const key in data) {
            formData.append(key, normalizeFormValue(that[key]))
        }


        if (this.file && this.file.length > 0) {
            formData.append('file', this.file)
        }

        return formData
    },


    _redirectTo() {
        return window.location.reload()
    }
})
